import React from "react";
import { Button, Popover, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../redux";
import SurveySegment1 from "./SurveySegment1";
import SurveyFeedback from "./SurveyFeedback";
type Props = {};
export const SurveyPopover: React.FC<Props> = ({ }) => {
  const { open, survey } = useSelector((state: ReduxState) => state.Survey);
  if (!open) {
    return null;
  }
  if (!["segment1", "feedback"].includes(survey)) {
    return null;
  }
  const popoverStyles = {
    position: "fixed" as "fixed",
    bottom: 0,
    right: 50,
    zIndex: 1050, // Ensure it's above most other content; adjust as needed
  };

  return (
    <div style={popoverStyles}>
      <Popover id="popover-positioned-bottom-right">
        <Popover.Content>
          {survey === "segment1" && <SurveySegment1 />}
          {survey === "feedback" && <SurveyFeedback />}
        </Popover.Content>
      </Popover>
    </div>
  );
};
export default SurveyPopover;
